import React from 'react'
import styled, { css } from 'styled-components'
import FlexBox from '../../../components/FlexBox/FlexBox'
import PlusIcon from '../../../components/Icons/components/PlusIcon'
import { Link } from 'react-router-dom'
import { useQuery } from 'react-query'
import RecommendedProductsService from '../../../services/RecommendedProductsService'
import {
    selectMainProduct,
    selectMinimalMonthsParsed,
    selectShopUuid,
} from "../../../features/basketSlice";
import { useSelector } from 'react-redux'
import RecommendedProduct from './RecommendedProduct'
import Spiner from '../../../components/Spiner/Spiner'


import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import 'swiper/swiper-bundle.min';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const RecommendedServicesSlider = () => {

    const shopUuid = useSelector(selectShopUuid);
    const mainProduct = useSelector(selectMainProduct);
    const minimalMonths = useSelector(selectMinimalMonthsParsed);


    const { data, isSuccess, isLoading } = useQuery(
        ['recommended-services', shopUuid, mainProduct.id, minimalMonths],
        RecommendedProductsService.getAllRecommendedProducts('ALL_SERVICES', shopUuid, minimalMonths, mainProduct.id, { limit: 4 })
    )


    return (
        <StyledRecommendedAccesories>
            <Header>
                <IconWrapper>
                    <PlusIcon width={20} height={20} />
                </IconWrapper>
                <HeaderText>Dodaj usługi</HeaderText>
            </Header>
            <Slider>
                {
                    isLoading && <Spiner />
                }
                {
                    isSuccess && (
                        <Swiper
                            className='slider'
                            modules={[Navigation]}
                            slidesPerView={2}
                            spaceBetween={-40}
                        >
                            {
                                data.items.map((item, index) => (
                                    <SwiperSlide key={index}>
                                        <Link to={`/products-collections/all_services/${item.details.id}`}>
                                            <RecommendedProduct data={item} className='recommendedProduct' />
                                        </Link>
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                    )
                }
            </Slider>
            <FlexBox alignItems='center' justifyContent='flex-end' gap="10px" margin='0 15px 0 0'>
                <StyledLink to='/categories/all_services' disabled={isLoading}>
                    Wyświetl wszystkie usługi
                </StyledLink>
                <Icon />
            </FlexBox>
        </StyledRecommendedAccesories>
    )
}

export default RecommendedServicesSlider

const StyledRecommendedAccesories = styled.div`
    .swiper-slide {
        padding-right: 50px;
        height: auto;
    }
`

const Icon = styled(PlusIcon)`
    color: ${props => props.theme.primary};
    font-size: 20px;
`

const disabledLinkStyle = css`
    pointer-events: none;
    opacity: 0.3;
`

const StyledLink = styled(Link)`
    text-decoration: underline;
    ${props => props.disabled && disabledLinkStyle}
`

const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;

`
const IconWrapper = styled.div`
    color: ${props => props.theme.primary};
    display: flex;
`
const HeaderText = styled.div`
    font-size: 17px;
    font-weight: bold;
`

const Slider = styled.div`
    margin-bottom: 20px;
`

